module.exports = __webpack_public_path__ + "img/xingtai-69e4ba.png";